const styles = (theme) => ({
  contentContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: theme.spacing(2),
  },
  caption: {
    fontSize: theme.spacing(2),
    fontWeight: 400,
    letterSpacing: 0.5,
  },
  value: {
    fontSize: theme.spacing(2.5),
    color: theme.color.black,
  },
  associateValue: {
    fontSize: theme.spacing(2.5),
    color: theme.color.grey_8A,
  },
  salesThrough: {
    fontSize: theme.spacing(1.5),
    paddingTop: theme.spacing(1),
  },
});

export default styles;
